
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Product } from "@/lib/types";

interface ProductComparisonProps {
  products: Product[];
  filteredUsageRecords: any[];
  filteredStockUpdates: any[];
}

const ProductComparison = ({ products, filteredUsageRecords, filteredStockUpdates }: ProductComparisonProps) => {
  // Generate data for the comparison chart
  const comparisonData = products.map(product => {
    const usage = filteredUsageRecords
      .filter(record => record.productId === product.id)
      .reduce((sum, record) => sum + record.quantity, 0);
    
    const stockAdded = filteredStockUpdates
      .filter(update => update.productId === product.id)
      .reduce((sum, update) => sum + update.quantity, 0);
    
    return {
      name: product.name,
      currentStock: product.currentStock,
      usage,
      stockAdded,
      daysRemaining: Math.floor(product.currentStock / (product.actualUsageRate || product.usageRate))
    };
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>Stock Levels by Product</CardTitle>
        <CardDescription>
          Current stock, usage, and additions during the selected period
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[400px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={comparisonData}
              margin={{ top: 20, right: 30, left: 20, bottom: 70 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis 
                dataKey="name" 
                angle={-45} 
                textAnchor="end" 
                height={70} 
              />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="currentStock" name="Current Stock" fill="#3b82f6" />
              <Bar dataKey="usage" name="Used" fill="#ef4444" />
              <Bar dataKey="stockAdded" name="Added" fill="#22c55e" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProductComparison;
